module.exports = __webpack_public_path__ + "img/aha-slides-gpt-3.85cfd7c2.webp";